import Swal from 'sweetalert2';

const SWAL_CUSTOM_CLASS = {
  container: 'swal-modal-overlay',
  popup: 'swal-popup-rounded',
};

const SWAL_MOTION = {
  showClass: {
    popup: 'swal2-soft-show',
    backdrop: 'swal2-backdrop-soft-show',
  },
  hideClass: {
    popup: 'swal2-soft-hide',
    backdrop: 'swal2-backdrop-soft-hide',
  },
};

/** Instancia con clases, animación y estilo unificados. */
export const modalSwal = Swal.mixin({
  customClass: SWAL_CUSTOM_CLASS,
  buttonsStyling: true,
  ...SWAL_MOTION,
});

/**
 * SweetAlert configurado para aparecer por encima de modales de Bootstrap
 */
export const showModalAlert = (options) => {
  return modalSwal.fire({
    ...options,
    customClass: {
      ...SWAL_CUSTOM_CLASS,
      ...options.customClass,
    },
  });
};

/**
 * Diálogo de carga — solo círculo, entrada suave (sin texto brusco).
 */
export const showModalLoading = () => {
  return modalSwal.fire({
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    showCloseButton: false,
    width: 'auto',
    padding: '1.25rem',
    customClass: {
      ...SWAL_CUSTOM_CLASS,
      popup: 'swal-popup-rounded swal2-loading-minimal',
    },
    html: '<div class="ui-soft-spinner-wrap"><span class="spinner-border text-primary" role="status" aria-label="Espere"></span></div>',
    didOpen: () => {
      Swal.getPopup()?.classList.add('swal2-loading-minimal');
    },
  });
};

export const closeSwal = () => Swal.close();

/**
 * SweetAlert normal (para usar fuera de modales)
 */
export const showAlert = (options) => {
  return Swal.mixin({ ...SWAL_MOTION }).fire({
    customClass: { popup: 'swal-popup-rounded' },
    ...options,
  });
};

/**
 * Alerta de confirmación para modales
 */
export const showModalConfirm = (options) => {
  return showModalAlert({
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#dc3545',
    cancelButtonColor: '#64748b',
    confirmButtonText: 'Sí, continuar',
    cancelButtonText: 'Cancelar',
    ...options,
  });
};

export const showModalSuccess = (title, text = '') => {
  return showModalAlert({
    icon: 'success',
    title,
    text,
    confirmButtonColor: '#00a1ff',
  });
};

export const showModalError = (title, text) => {
  return showModalAlert({
    icon: 'error',
    title,
    text,
    confirmButtonColor: '#00a1ff',
  });
};

export const showModalWarning = (title, text) => {
  return showModalAlert({
    icon: 'warning',
    title,
    text,
    confirmButtonColor: '#00a1ff',
  });
};

export const confirmDiscardUnsaved = async (text, options = {}) => {
  const { isConfirmed } = await showModalAlert({
    icon: 'warning',
    title: options.title || 'Cambios sin guardar',
    text,
    showCancelButton: true,
    confirmButtonText: options.confirmText || 'Salir sin guardar',
    cancelButtonText: options.cancelText || 'Seguir editando',
    confirmButtonColor: options.confirmButtonColor || '#dc3545',
    cancelButtonColor: options.cancelButtonColor || '#64748b',
    reverseButtons: true,
    focusCancel: true,
    ...options,
  });
  return isConfirmed;
};

/** Confirmar cancelación de cita en agenda del consultorio. */
export const confirmCancelarCita = async () => {
  const { isConfirmed } = await showModalAlert({
    icon: 'warning',
    title: '¿Cancelar esta cita?',
    text: 'Podés volver a agendarla después.',
    showCancelButton: true,
    confirmButtonText: 'Sí, cancelar',
    cancelButtonText: 'No, mantener',
    confirmButtonColor: '#dc3545',
    cancelButtonColor: '#64748b',
    reverseButtons: true,
    focusCancel: true,
  });
  return isConfirmed;
};

export default Swal;
